import { LitElement, css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'

/**
 * A customizable "share" button
 * Usage:
 *    <ep-share-url-button share-title="Title" share-description="Description" href="https://google.com"></ep-share-url-button>
 */
@customElement('ep-share-url-button')
export class EPShareUrlButton extends LitElement {

  @property({ attribute: 'share-title', reflect: true })
  shareTitle: string = ''

  @property({ attribute: 'share-description', reflect: true })
  shareDescription: string = ''

  @property({ attribute: 'href', reflect: true })
  href: string = ''

  protected updated() {
    this.setAttribute('title', this.shareTitle);
  }

  render() {
    return html`
      <svg @click=${this.triggerShare} xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewbox="0 0 20 20">
        <path d="M5.5 19q-.625 0-1.062-.438Q4 18.125 4 17.5v-9q0-.625.438-1.062Q4.875 7 5.5 7H8v1.5H5.5v9h9v-9H12V7h2.5q.625 0 1.062.438Q16 7.875 16 8.5v9q0 .625-.438 1.062Q15.125 19 14.5 19Zm3.75-6V3.875L8.062 5.062 7 4l3-3 3 3-1.062 1.062-1.188-1.187V13Z"/>
      </svg>
    `
  }

  async triggerShare() {
    try {
      const shareData = {
        title: this.shareTitle,
        text: this.shareDescription,
        url: this.href,
      }

      if (!navigator.canShare) {
        // navigator.canShare() not supported.
        await this.copyToClipboard();
      }
      else if (navigator.canShare(shareData)) {
        // navigator.canShare() supported. We can use navigator.share() to send the data.
        await navigator.share(shareData);
      } else {
        // Specified data cannot be shared.
        await this.copyToClipboard();
      }
    }
    catch {
      console.error('[ep-share-url-button] Failed to trigger share')
    }
  }

  async copyToClipboard() {
    try {
      await navigator.clipboard.writeText(this.href);
      alert(`Copied to clipboard: ${this.href}`);
    }
    catch {
      console.error('[ep-share-url-button] Failed to copy to clipboard')
    }
  }

  static styles = css`
    :host {
      display: inline-block;
      fill: #315686;
      transition: all 125ms;
      
    }
    :host(:hover) {
      fill: maroon;
      transform: scale(1.05);
      cursor: pointer;
    }
    :host(:active) {
      transform: scale(0.925);
    }
    svg {
      width: inherit;
      height: inherit;
      object-fit: contain;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-share-url-button': EPShareUrlButton
  }
}
